import Flex from '@react-css/flex'
import axios from 'axios'
import { useQuery } from 'react-query'
import { Link, useRouteMatch } from 'react-router-dom'
import styled from 'styled-components'

import imgMapMarker from '../../../../assets/images/icon_map_marker.svg'
import { useAdminZoneContext } from '../../../../contexts/adminZoneContext'
import { useViewportWidth } from '../../../../hooks/useViewportWidth'
import { BREAKPOINTS, media } from '../../../../styles/breakpoints'
import { Icon } from '../../../common/Icon'
import { LoadingIndicator } from '../../../common/LoadingIndicator'

const API_BASE = process.env.REACT_APP_NEXTERA_API

export const BuildingPageHeaderOutlet = () => {
  const { adminPrefix, inAdminZone } = useAdminZoneContext()
  const viewportWidth = useViewportWidth()
  const isMobileLayout = viewportWidth < BREAKPOINTS.tablet

  const buildingMatch = useRouteMatch<{
    projectId: string
    floorId: string
    pointId: string
  }>()

  const { projectId, floorId, pointId } = buildingMatch.params

  let url = `${API_BASE}/project/${projectId}`
  if (floorId) url = `${API_BASE}/project/${projectId}/floor/${floorId}`

  const fetchProjects = async () => {
    // eslint-disable-next-line no-console -- TODO: Remove debug console.log
    console.log('URL in header', url)
    return axios
      .get(url)
      .then(res => res.data)
      .then(response => response.data)
      .catch(err => {
        // eslint-disable-next-line no-console -- TODO: Replace with proper error logging
        console.log('errr==>>', err)
      })
  }

  const buildingQuery = useQuery(
    ['buildingHeader', projectId, floorId, pointId],
    fetchProjects,
  )

  const buildingDesc = buildingQuery.data

  if (buildingQuery.isLoading) return <LoadingIndicator fb={true} />

  if (buildingDesc) {
    return (
      <HeaderOutlet $inAdminZone={inAdminZone}>
        <HeaderTitleLink
          $inAdminZone={inAdminZone}
          $isMobileLayout={isMobileLayout}
          to={`${adminPrefix}/project/${projectId}`}
        >
          {buildingDesc.name}
        </HeaderTitleLink>
        <LocationRow alignItems={'center'} justifyContent={'center'}>
          <Icon icon={imgMapMarker} size={16} style={{ marginRight: '6px' }} />
          <LocationText>
            {buildingDesc.location.city}, {buildingDesc.location.state_code}
          </LocationText>
        </LocationRow>
      </HeaderOutlet>
    )
  }
  return <></>
}

const HeaderOutlet = styled(Flex)<{ $inAdminZone?: boolean }>`
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
  padding: 0 8px;
  box-sizing: border-box;

  @media ${media.belowTablet} {
    padding: 0 4px;
    max-width: ${props =>
      props.$inAdminZone ? 'calc(100vw - 136px)' : '100%'};
  }
`

const HeaderTitleLink = styled(Link)<{
  $inAdminZone?: boolean
  $isMobileLayout?: boolean
}>`
  color: #000;
  display: block;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: 4px;
  overflow: hidden;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: ${props => {
    if (!props.$inAdminZone) return '100%'
    return props.$isMobileLayout ? '100%' : 'min(420px, calc(100vw - 360px))'
  }};

  @media ${media.belowTablet} {
    font-size: 14px;
  }
`

const LocationRow = styled(Flex)`
  @media ${media.belowTablet} {
    display: none;
  }
`

const LocationText = styled.span`
  color: #7e858e;
  font-size: 14px;
  margin-top: 2px;
`
